import { render, staticRenderFns } from "./JobCategoriesSectionModule.vue?vue&type=template&id=83b1ad3a&"
import script from "./JobCategoriesSectionModule.vue?vue&type=script&lang=js&"
export * from "./JobCategoriesSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports